import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { getScanData, getProduct } from './services/scantrust'
// import * as serviceWorker from './serviceWorker'

const render = async () => {
  const domElement = document.getElementById(
    'serverless-landing-from',
  )
  // TODO Uncomment for locale testing
  // const getLocale = window.location.pathname.split('/')[1]
  // if (getLocale) {
  //   domElement.setAttribute('locale', `${getLocale}`)
  // }
  const locale = domElement.getAttribute('locale').toLowerCase()
  const campaign = domElement.getAttribute('campaign').toLowerCase()
  const version = domElement.getAttribute('version')
    ? domElement.getAttribute('version').toLowerCase()
    : 0

  const dataPoints = await fetch(process.env.REACT_APP_POINTS_URL)

  const dataFetch = await fetch(
    `${process.env.REACT_APP_ASSETS_URL}${campaign}/data.${version}.json`,
  )
  const localeItemsFetch = await fetch(
    `${process.env.REACT_APP_ASSETS_URL}${campaign}/locales/${locale}.${version}.json`,
  )

  /* Fetch extra data */
  // const extraDataFetch =
  //   locale === 'en-us' &&
  //   (await fetch(
  //     `${process.env.REACT_APP_ASSETS_URL}${campaign}/extradata.${version}.json`,
  //   ))

  if (dataFetch.status === 200 && localeItemsFetch.status === 200) {
    let data = await dataFetch.json()
    const localeItems = await localeItemsFetch.json()
    // const extraData =
    //   extraDataFetch.status === 200 && locale === 'en-us'
    //     ? await extraDataFetch.json()
    //     : null

    if (campaign === '01-21_consumer') {
      const scanData = await getScanData()
      if (scanData) {
        const points = await dataPoints.json()
        const product = parseInt(scanData.data.product, 10);
        const scanPoints = points[product] ?? null

        if (scanData.data.product) {
          const scanProduct = getProduct(scanData.data.product)
          scanData.data = {
            ...scanData.data,
            productName: scanProduct,
          }
        }
        if (scanPoints === null) {
          scanData.data.state = 'ERROR'
        }
        data = { ...data, scanPoints, scanData }
      }
    }

    ReactDOM.render(
      <div className={locale}>
        <App data={data} localeItems={localeItems} locale={locale} />
      </div>,
      domElement,
    )
  } else {
    console.log('error: campaign or locale attribute are incorrect')
  }
}

render()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
